import type { ScholarshipPlayer } from '../../../../types/scholarships';
import { formatMoney } from './scholarshipMoney';

interface Props {
  // The currently FILTERED players — totals follow the visible set (plan-wide
  // totals live in the summary band's budget cards).
  players: ScholarshipPlayer[];
  showNil: boolean;
  showRevShare: boolean;
}

// Money totals under the players tables. Cells gate per-toggle: Total NIL needs NIL
// tracking, Total Rev Share needs Rev Share tracking, Total Package shows for either.
export const ScholarshipTotalsStrip = ({ players, showNil, showRevShare }: Props) => {
  if (!showNil && !showRevShare) return null;

  // Total Package is FULL compensation (award + NIL + rev share) even when one
  // bucket's tracking is off — the toggles gate which budgets are tracked, not
  // what a player is actually paid. (Plan decision: Total Package = award + nil
  // + revShare in every model.)
  let nilTotal = 0;
  let revShareTotal = 0;
  let packageTotal = 0;
  for (const p of players) {
    nilTotal += p.nilAmount ?? 0;
    revShareTotal += p.revShare ?? 0;
    packageTotal += (p.award ?? 0) + (p.nilAmount ?? 0) + (p.revShare ?? 0);
  }

  return (
    <div className="scholarship-totals" data-testid="scholarship-totals-strip">
      {showNil && (
        <div className="scholarship-totals__item">
          <span className="scholarship-totals__label">Total NIL</span>
          <span className="scholarship-totals__value" data-testid="totals-nil">
            {formatMoney(nilTotal)}
          </span>
        </div>
      )}
      {showRevShare && (
        <div className="scholarship-totals__item">
          <span className="scholarship-totals__label">Total Rev Share</span>
          <span className="scholarship-totals__value" data-testid="totals-rev-share">
            {formatMoney(revShareTotal)}
          </span>
        </div>
      )}
      <div className="scholarship-totals__item">
        <span className="scholarship-totals__label">Total Package</span>
        <span className="scholarship-totals__value" data-testid="totals-package">
          {formatMoney(packageTotal)}
        </span>
      </div>
    </div>
  );
};
